import { IObject } from '@/types'

export const useRemoveNullUndefined = (obj: IObject) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null && v !== ''))
}
